import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function LowDownPaymentPage() {
  return (
    <LoanProgramTemplate
      title="Low Down Payment Program"
      subtitle="Alternative Options"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907400/Low_Down_Payment_k1zkzk.png"
      descriptionBold="Low down payment programs"
      description="let buyers purchase a home with a smaller upfront investment—often 0 to 3.5 percent—while allowing the use of grants or gift funds. They help buyers move forward sooner and preserve savings."
      whyBuyersConsider="These programs can reduce the cash needed at closing and may offer long term savings opportunities, making homeownership more attainable for buyers early in their financial journey."
      eligibilityItems={[
        'Works with several common loan types used by first time and repeat buyers',
        'Allows buyers to combine down payment assistance with standard loan approval',
        'Requires buyers to meet standard property and occupancy guidelines',
      ]}
      benefitsItems={[
        'Helps buyers preserve cash for moving costs, furnishings, or emergencies',
        'Expands options for buyers who are early in their savings journey',
        'Makes it easier to compete with stronger offers by reducing upfront barriers',
      ]}
    />
  );
}
